function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useContext, useState, useRef, useMemo, useEffect } from 'react';
import { SimplifiedCheckEligibilityModal, useLocalStorageBackedDsjState, useSimplifiedSchoolEligibilityApi, useStudentProfileInDsjState } from '@applyboard/dsj-ui';
import { useSetPageMeta, UserContext, getEditProgramPath, verifyRole, useEventTracker } from '@applyboard/ui-utils';
import { Box, NavigationTabs } from '@applyboard/ui-components';
import { AppContext } from "../../context";
import { useProgramInitialProps, useProgram, useScholarships } from "../../data";
import { LoadingOverlay, SchoolHeader } from "../../components";
import { displayMobileOnly, displayDesktopOnly } from "../../consts";
import { extractProgram, getIncludedSchool, getProgramRequirements, getProgramEnglishRequirementExceptions, getPrerequisiteEnglishProgramRequirements, getPrerequisiteEnglishRequirementExceptions, getSchoolPhotos, getProgramIntakes, getProgramTags } from "./utils";
import { useStyle } from "./useStyle";
import { RightColumn } from "./RightColumn";
import { LeftColumn } from "./LeftColumn";
function ProgramPage(_ref) {
  var _school$logo;
  var programSlug = _ref.programSlug,
    schoolSlug = _ref.schoolSlug,
    hideEligibility = _ref.hideEligibility;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var appContext = useContext(AppContext);
  var currentUser = useContext(UserContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var refSectionAbout = useRef(null);
  var refSectionRequirements = useRef(null);
  var refSectionScholarships = useRef(null);
  var refSectionPrograms = useRef(null);
  var _useStyle = useStyle(),
    rootStyle = _useStyle.rootStyle,
    columnContentStyle = _useStyle.columnContentStyle;
  var _useProgramInitialPro = useProgramInitialProps(schoolSlug, programSlug),
    programInitialProps = _useProgramInitialPro.programInitialProps;
  var _useProgram = useProgram(programInitialProps === null || programInitialProps === void 0 ? void 0 : programInitialProps.programId),
    program = _useProgram.program;
  var programData = extractProgram(program);
  var programId = programData === null || programData === void 0 ? void 0 : programData.id;
  var commissionData = programData === null || programData === void 0 ? void 0 : programData.commission;
  useSetPageMeta({
    title: programData === null || programData === void 0 ? void 0 : programData.name,
    description: programData === null || programData === void 0 ? void 0 : programData.description
  });
  var openModal = useCallback(function () {
    return setModalOpen(true);
  }, [setModalOpen]);
  var closeModal = useCallback(function () {
    return setModalOpen(false);
  }, [setModalOpen]);
  var trackTabNavigateEvent = useCallback(function (_ref2) {
    var title = _ref2.title;
    trackEvent({
      event: 'Programs Page - Clicked Anchor-Point',
      data: {
        anchor: title
      }
    });
  }, [trackEvent]);
  var trackApplyClicked = useCallback(function (isIgnoringEligibility, student_id) {
    trackEvent({
      event: "Program Page - Eligibility Modal - Click ".concat(isIgnoringEligibility ? 'Apply Anyway' : 'Apply Now'),
      data: {
        program_id: programId,
        school_id: programInitialProps === null || programInitialProps === void 0 ? void 0 : programInitialProps.schoolId,
        user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        student_id: student_id
      }
    });
  }, [programId, programInitialProps, currentUser, trackEvent]);
  var onApplyClicked = useCallback(function (isIgnoringEligibility, student_id) {
    trackApplyClicked(isIgnoringEligibility, student_id);
  }, [trackApplyClicked]);
  var programTags = useMemo(function () {
    return programData ? getProgramTags(programData, program === null || program === void 0 ? void 0 : program.included) : [];
  }, [programData, program]);
  var eligibilities = useSimplifiedSchoolEligibilityApi(appContext.dsjState, programId ? [programId] : null, (programInitialProps === null || programInitialProps === void 0 ? void 0 : programInitialProps.schoolId) || '');
  var school = getIncludedSchool(programData, program === null || program === void 0 ? void 0 : program.included);
  var _useScholarships = useScholarships(programId || ''),
    scholarships = _useScholarships.scholarships;
  var showScholarships = scholarships && scholarships.length > 0;
  useEffect(function () {
    var _programInitialProps$, _programInitialProps$2, _programInitialProps$3, _programInitialProps$4, _programInitialProps$5, _programInitialProps$6;
    var showGic = !!(programInitialProps !== null && programInitialProps !== void 0 && (_programInitialProps$ = programInitialProps.featureFlags) !== null && _programInitialProps$ !== void 0 && (_programInitialProps$2 = _programInitialProps$.showVas) !== null && _programInitialProps$2 !== void 0 && _programInitialProps$2.gic);
    var showLoan = !!(programInitialProps !== null && programInitialProps !== void 0 && (_programInitialProps$3 = programInitialProps.featureFlags) !== null && _programInitialProps$3 !== void 0 && (_programInitialProps$4 = _programInitialProps$3.showVas) !== null && _programInitialProps$4 !== void 0 && _programInitialProps$4.loan);
    var showApplyShop = !!(programInitialProps !== null && programInitialProps !== void 0 && (_programInitialProps$5 = programInitialProps.featureFlags) !== null && _programInitialProps$5 !== void 0 && (_programInitialProps$6 = _programInitialProps$5.showVas) !== null && _programInitialProps$6 !== void 0 && _programInitialProps$6.applyShop);
    var programName = programData === null || programData === void 0 ? void 0 : programData.name;
    var schoolId = programInitialProps === null || programInitialProps === void 0 ? void 0 : programInitialProps.schoolId;
    var schoolName = school === null || school === void 0 ? void 0 : school.name;
    if ((showGic || showLoan || showApplyShop) && programData && programId && programName && schoolId && schoolName) {
      var displayedVasCards = [].concat(_toConsumableArray(showGic ? ['GIC'] : []), _toConsumableArray(showLoan ? ['LOAN'] : []), _toConsumableArray(showApplyShop ? ['APPLY_SHOP'] : []));
      trackEvent({
        event: 'VAS cards displayed',
        data: {
          source: 'Program Landing Page',
          displayedVasCards: displayedVasCards,
          programId: programId,
          programName: programName,
          schoolId: schoolId,
          schoolName: schoolName
        }
      });
    }
  }, [programInitialProps, programData, school]);
  if (!programData || !programInitialProps) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, null);
  }
  var schoolPhotos = getSchoolPhotos(program === null || program === void 0 ? void 0 : program.included).map(function (photo) {
    return {
      id: photo.id,
      photoFileName: photo.fileName,
      original: photo.url,
      optimized: photo.urlOptimized,
      optimizedSmall: photo.urlOptimizedSmall,
      thumbnail: photo.urlThumbnail,
      type: 'image'
    };
  });
  var programRequirements = getProgramRequirements(programData, program === null || program === void 0 ? void 0 : program.included);
  var programEnglishRequirementsExceptions = getProgramEnglishRequirementExceptions(programData, program === null || program === void 0 ? void 0 : program.included);
  var pepRequirements = getPrerequisiteEnglishProgramRequirements(programData, program === null || program === void 0 ? void 0 : program.included);
  var pepRequirementExceptions = getPrerequisiteEnglishRequirementExceptions(programData, program === null || program === void 0 ? void 0 : program.included);
  var intakes = getProgramIntakes(program === null || program === void 0 ? void 0 : program.included);
  var editProgram = getEditProgramPath(school === null || school === void 0 ? void 0 : school.schoolGroupId, school === null || school === void 0 ? void 0 : school.id, programData === null || programData === void 0 ? void 0 : programData.id);
  var sections = [{
    hash: 'about',
    title: 'Overview',
    ref: refSectionAbout
  }].concat(_toConsumableArray(programRequirements ? [{
    hash: 'requirements',
    title: 'Admission Requirements',
    ref: refSectionRequirements
  }] : []), _toConsumableArray(showScholarships ? [{
    hash: 'scholarships',
    title: 'Scholarships',
    ref: refSectionScholarships
  }] : []), [{
    hash: 'programs',
    title: 'Similar Programs',
    ref: refSectionPrograms
  }]);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: _objectSpread(_objectSpread({}, appContext), {}, {
      program: programData,
      initialProps: programInitialProps,
      eligibility: eligibilities,
      hideEligibility: hideEligibility
    })
  }, /*#__PURE__*/React.createElement(Box, {
    className: rootStyle,
    pb: {
      xs: 0,
      md: 6
    }
  }, /*#__PURE__*/React.createElement(Box, {
    px: {
      xs: 0,
      md: 11
    }
  }, /*#__PURE__*/React.createElement(SchoolHeader, {
    programId: programId,
    programName: programData.name,
    schoolName: school === null || school === void 0 ? void 0 : school.name,
    countryCode: school === null || school === void 0 ? void 0 : school.countryCode,
    city: school === null || school === void 0 ? void 0 : school.city,
    state: school === null || school === void 0 ? void 0 : school.province,
    logo: school === null || school === void 0 ? void 0 : (_school$logo = school.logo) === null || _school$logo === void 0 ? void 0 : _school$logo.url,
    to: "/schools/".concat(school === null || school === void 0 ? void 0 : school.slug),
    images: schoolPhotos,
    video: school === null || school === void 0 ? void 0 : school.videoLink,
    editLink: editProgram,
    isProgramPublished: verifyRole.isInternalStaff(currentUser) || programData.published === false ? !!programData.published : null,
    lastUpdated: verifyRole.isInternalStaff(currentUser) ? programData.updatedAt : null,
    cover: (schoolPhotos === null || schoolPhotos === void 0 ? void 0 : schoolPhotos.length) > 0 ? schoolPhotos[0].optimized : undefined,
    coverFallback: (schoolPhotos === null || schoolPhotos === void 0 ? void 0 : schoolPhotos.length) > 0 ? schoolPhotos[0].original : undefined,
    programWebsite: programData.url,
    programTags: programTags
  }), /*#__PURE__*/React.createElement(Box, {
    display: displayDesktopOnly
  }, /*#__PURE__*/React.createElement(NavigationTabs, {
    sections: sections,
    onChangeTab: trackTabNavigateEvent
  }))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    pt: 6,
    className: columnContentStyle,
    px: {
      xs: 0,
      md: 11
    }
  }, /*#__PURE__*/React.createElement(Box, {
    flex: "2"
  }, /*#__PURE__*/React.createElement(LeftColumn, {
    currentUser: currentUser,
    eligibilities: eligibilities,
    openModal: openModal,
    pepRequirementExceptions: pepRequirementExceptions,
    pepRequirements: pepRequirements,
    program: program,
    programData: programData,
    programEnglishRequirementsExceptions: programEnglishRequirementsExceptions,
    programInitialProps: programInitialProps,
    programRequirements: programRequirements,
    schoolName: school === null || school === void 0 ? void 0 : school.name,
    sectionRefs: {
      about: refSectionAbout,
      requirements: refSectionRequirements,
      programs: refSectionPrograms,
      scholarships: refSectionScholarships
    },
    scholarships: scholarships || []
  }, /*#__PURE__*/React.createElement(Box, {
    display: displayMobileOnly
  }, /*#__PURE__*/React.createElement(RightColumn, {
    openModal: openModal,
    programInitialProps: programInitialProps,
    programData: programData,
    schoolName: school === null || school === void 0 ? void 0 : school.name,
    livingCost: school === null || school === void 0 ? void 0 : school.costOfLiving,
    intakes: intakes,
    commissionData: commissionData,
    currentUser: currentUser,
    programRequirements: programRequirements,
    eligibilities: eligibilities
  })))), /*#__PURE__*/React.createElement(Box, {
    flex: "1",
    ml: 5,
    display: displayDesktopOnly
  }, /*#__PURE__*/React.createElement(RightColumn, {
    openModal: openModal,
    programInitialProps: programInitialProps,
    programData: programData,
    schoolName: school === null || school === void 0 ? void 0 : school.name,
    livingCost: school === null || school === void 0 ? void 0 : school.costOfLiving,
    intakes: intakes,
    commissionData: commissionData,
    currentUser: currentUser,
    programRequirements: programRequirements,
    eligibilities: eligibilities
  })))), /*#__PURE__*/React.createElement(SimplifiedCheckEligibilityModal, {
    open: modalOpen,
    onClose: closeModal,
    programId: programId,
    setDsjState: appContext.setDsjState,
    onApplyClicked: onApplyClicked,
    openModal: openModal
  }));
}
function ProgramPageStudent(props) {
  var _useContext;
  var userId = (_useContext = useContext(UserContext)) === null || _useContext === void 0 ? void 0 : _useContext.id;
  var _useStudentProfileInD = useStudentProfileInDsjState(userId),
    _useStudentProfileInD2 = _slicedToArray(_useStudentProfileInD, 2),
    dsjState = _useStudentProfileInD2[0],
    setDsjState = _useStudentProfileInD2[1];
  var appContext = useContext(AppContext);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: _objectSpread(_objectSpread({}, appContext), {}, {
      dsjState: dsjState,
      setDsjState: setDsjState
    })
  }, /*#__PURE__*/React.createElement(ProgramPage, props));
}
function ProgramPagePws(props) {
  var _useLocalStorageBacke = useLocalStorageBackedDsjState(),
    _useLocalStorageBacke2 = _slicedToArray(_useLocalStorageBacke, 2),
    dsjState = _useLocalStorageBacke2[0],
    setDsjState = _useLocalStorageBacke2[1];
  var appContext = useContext(AppContext);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    value: _objectSpread(_objectSpread({}, appContext), {}, {
      dsjState: dsjState,
      setDsjState: setDsjState
    })
  }, /*#__PURE__*/React.createElement(ProgramPage, props));
}
export default function ProgramPageSetup(props) {
  var currentUser = useContext(UserContext);
  var userRole = currentUser === null || currentUser === void 0 ? void 0 : currentUser.role;
  if (!userRole) {
    return /*#__PURE__*/React.createElement(ProgramPagePws, props);
  }
  if (userRole === 'student') {
    return /*#__PURE__*/React.createElement(ProgramPageStudent, props);
  }
  return /*#__PURE__*/React.createElement(ProgramPage, props);
}